import { LabelValueTextPair } from '@components';
import Loader from '@components/AppLoader/Loader';
import { KeyTerms as KeyTermsDataProps } from '@features/api/response/tabContent/KeyTerms';
import { TabType } from '@features/api/response/tabContent/TabType';
import { useTabData } from '@hooks/useTabData';
import { Container } from './KeyTerms.styles';

const KeyTerms: React.FC = () => {
  const {
    data: keyTerms,
    isFetching,
    isLoading,
  } = useTabData<KeyTermsDataProps>(TabType.KEYTERMS);

  const sections = keyTerms?.sections ?? [];
  const sortedSections = sections.slice().sort(
    (x, y) => x.sequenceNumber - y.sequenceNumber
  );

  return (
    <Container>
      <Loader isLoading={isFetching || isLoading} />
      {sortedSections &&
        sortedSections.map((k) => (
          <LabelValueTextPair key={k.sequenceNumber} label={k.key} value={k.value} />
        ))}
    </Container>
  );
};

export default KeyTerms;
